<div fxLayout="column" fxLayoutGap="25px">

  <div fxLayout="row">
    <div fxLayoutAlign="center center">
      <kendo-icon name="info" [themeColor]="'info'" [size]="'medium'"> </kendo-icon>
    </div>
    <div>
      <strong class="disclaimer">{{ "claims-center.claimDocumentation.linkDisclaimer" | translate }}</strong>
    </div>
  </div>

  <div>
    <form [formGroup]="exportLinkForm">

      <div fxLayout="row wrap" fxLayoutAlign="center start" fxLayoutGap="10px">
        <date-time-input-ctrl [settings]="{fxFill:true}"
          [caption]="'claims-center.claimDocumentation.linkExpirationDate'" [formControlName]="'expirationDate'">
        </date-time-input-ctrl>
        <button kendoButton (click)="generateLink()" submit>{{ "claims-center.claimDocumentation.generateLink" |
          translate }}</button>
      </div>

    </form>
  </div>


</div>


<app-loading-panel [isLoading]="isLoading"></app-loading-panel>

<div *ngIf="!isLoading && !!linkUrl" class="form-block" fxLayout="column" fxLayoutAlign="Center center">
  <div>
    <strong>{{ "claims-center.claimDocumentation.generatedLink" | translate }}</strong>
  </div>
  <div fxLayoutGap="20px">
    <a [href]="linkUrl" target="_blank">{{ linkUrl }}</a>
    <button kendoButton fillMode="flat" title="Copy" [cdkCopyToClipboard]="linkUrl" icon="share" class="copyButton"
      (click)="copyLink()">{{
      "claims-center.claimDocumentation.copyToClipboard" | translate }}</button>
  </div>

</div>